/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LegacyQuizCategoryPage from './pages/LegacyQuizCategoryPage';
import LegacyQuizRewardPage from './pages/LegacyQuizRewardPage';
import LegacyQuizCategoryProductPage from './pages/LegacyQuizCategoryProductPage';
import LegacyQuizCategoryProductQuestionPage from './pages/LegacyQuizCategoryProductQuestionPage';
import LegacyQuizRewardReportPage from './pages/LegacyQuizRewardReportPage';
import LegacyQuizCategoryProductQuestionAnswerPage from './pages/LegacyQuizCategoryProductQuestionAnswerPage';
import LegacyQuizUserReportPage from './pages/LegacyQuizUserReportPage';
import LegacySurveyPage from '../survey/pages/LegacySurveyPage';
import LegacySurveyQuestionPage from '../survey/pages/LegacySurveyQuestionPage';
import LegacySurveyAnswerSelect from '../survey/pages/LegacySurveyAnswerSelect';
import LegacySurveyAnswerText from '../survey/pages/LegacySurveyAnswerText';
import LegacySurvey2Page from '../survey2/pages/LegacySurveyPage';
import LegacySurvey2QuestionPage from '../survey2/pages/LegacySurveyQuestionPage';
import LegacySurvey2AnswerSelect from '../survey2/pages/LegacySurveyAnswerSelect';
import LegacySurvey2AnswerMultiSelect from '../survey2/pages/LegacySurveyAnswerMultiSelect';
import LegacySurvey2AnswerText from '../survey2/pages/LegacySurveyAnswerText';
import LegacySurvey2PartPage from '../survey2/pages/LegacySurveyPartPage';
import LegacySurvey2AnswerSelectUserAnswerPage from '../survey2/pages/LegacySurveyAnswerSelectUserAnswerPage';

const queryClient = new QueryClient();

export default ({ match }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route
          path={`${match.path}/quiz/quiz-category`}
          exact
          children={<LegacyQuizCategoryPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-category/:categoryId`}
          exact
          children={<LegacyQuizCategoryProductPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-category/:categoryId/quiz-product/:productId`}
          exact
          children={<LegacyQuizCategoryProductQuestionPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-category/:categoryId/quiz-product/:productId/quiz-question/:questionId`}
          exact
          children={<LegacyQuizCategoryProductQuestionAnswerPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-reward/:rewardId`}
          exact
          children={<LegacyQuizRewardReportPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-reward`}
          exact
          children={<LegacyQuizRewardPage />}
        />
        <Route
          path={`${match.path}/quiz/quiz-user`}
          exact
          children={<LegacyQuizUserReportPage />}
        />
        <Route
          path={`${match.path}/survey/:surveyId`}
          exact
          children={<LegacySurveyQuestionPage />}
        />
        <Route
          path={`${match.path}/survey`}
          exact
          children={<LegacySurveyPage />}
        />
        <Route
          path={`${match.path}/survey/:surveyId/select/:questionId`}
          exact
          children={<LegacySurveyAnswerSelect />}
        />
        <Route
          path={`${match.path}/survey/:surveyId/text/:questionId`}
          exact
          children={<LegacySurveyAnswerText />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId`}
          exact
          children={<LegacySurvey2PartPage />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId/part/:partId`}
          exact
          children={<LegacySurvey2QuestionPage />}
        />
        <Route
          path={`${match.path}/survey2`}
          exact
          children={<LegacySurvey2Page />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId/part/:partId/multi_select/:questionId`}
          exact
          children={<LegacySurvey2AnswerMultiSelect />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId/part/:partId/select/:questionId`}
          exact
          children={<LegacySurvey2AnswerSelect />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId/part/:partId/select/:questionId/userAnswer/:userAnswerId`}
          exact
          children={<LegacySurvey2AnswerSelectUserAnswerPage />}
        />
        <Route
          path={`${match.path}/survey2/:surveyId/part/:partId/text/:questionId`}
          exact
          children={<LegacySurvey2AnswerText />}
        />
      </Switch>
    </QueryClientProvider>
  );
};
